import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DealStatusRecord } from 'app/models/dto/deal-status.model';
import { environment } from 'environments/environment';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable({ providedIn: 'root' })
export class DealStatusesService {
  protected apiUrl = `${environment.API_URL}`;

  constructor(private http: ApiHttpClient) {}

  getDealStatusesWithAliases(): Observable<DealStatusRecord[]> {
    return this.http.get<DealStatusRecord[]>(`${this.apiUrl}/deal-statuses`);
  }
}
